export default __webpack_public_path__ + "static/cosmos-2c9ee82d120ccf6b5729ab6eefdcd6a6.png";